module.exports = __webpack_public_path__ + "media/images/escudo-5c2e6544aae05c2c4e4049267ab85b60.svg";